import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@/feature/utils';

import { useUpdateProfile } from '../model/DashboardQuery';
import { UpdateProfileRequest } from '../model/DashboardTypes';
import { UpdateProfileForm } from './UpdateProfileForm';

export function UpdateProfileButton() {
  const { mutate, isPending } = useUpdateProfile();
  const { t } = useTranslation();
  const notification = useAppNotification();
  const [opened, { open, close }] = useDisclosure(false);

  const handleChange = (request: UpdateProfileRequest) =>
    mutate(request, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        close();
      },
    });

  return (
    <>
      <Button
        size="xs"
        variant="outline"
        loading={isPending}
        onClick={open}
      >
        {t('profile.updateProfile')}
      </Button>
      {opened && (
        <UpdateProfileForm
          onClose={close}
          isSubmitting={isPending}
          onChange={handleChange}
        />
      )}
    </>
  );
}
